/**
 * @generated SignedSource<<8de0ae6a42f6e8c5720b865557831965>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type productionTimeNoteHelper_transaction$data = {
  readonly isFullPriceOrder: boolean | null;
  readonly isNegotiable: boolean | null;
  readonly isShippingKnownAtCheckout: boolean | null;
  readonly " $fragmentType": "productionTimeNoteHelper_transaction";
};
export type productionTimeNoteHelper_transaction$key = {
  readonly " $data"?: productionTimeNoteHelper_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"productionTimeNoteHelper_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "productionTimeNoteHelper_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFullPriceOrder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNegotiable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isShippingKnownAtCheckout",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "f779bcb5c2984804b33725167c04a4e7";

export default node;
